import { useEffect } from 'react';

//Icons
import { ReactComponent as BackgroundLeft } from 'assets/images/auth/svg/graphic-left.svg';
import { ReactComponent as BackgroundRight } from 'assets/images/auth/svg/graphic-right.svg';

// Components
import LoadingDialog from 'components/LoadingDialog';

// Stores
import { useUserStore } from 'stores/user';

const TokenExpiryADFS = () => {
    const {
        actions: { logoutADFS },
    } = useUserStore();

    useEffect(() => {
        logoutADFS();
    }, []); //eslint-disable-line

    return (
        <div className={'app-main-login'}>
            <section className="login-svg-bg">
                <div className="login-svg-left">
                    <BackgroundLeft />
                </div>
                <div className={'login-svg-right'}>
                    <BackgroundRight />
                </div>
            </section>
            <LoadingDialog isOpen={true} title={'label.closing'} subtitle={'label.pleaseWait'} />
        </div>
    );
};

export default TokenExpiryADFS;
